export default function TournamentSummaryTable({ results }) {
  // group by tournamentType
  const grouped = results.reduce((acc, r) => {
    if (!acc[r.rankingType]) {
      acc[r.rankingType] = { tournaments: new Set(), medals: 0 };
    }
    // track unique tournament ids
    acc[r.rankingType].tournaments.add(r.tournamentId);

    // count medals if any
    if (["Gold", "Silver", "Bronze"].includes(r.medal)) {
      acc[r.rankingType].medals++;
    }

    return acc;
  }, {});

  const categories = Object.keys(grouped);

  if (categories.length === 0) {
    return <p className="text-gray-500">No tournament participation data found.</p>;
  }

  return (
    <div className="p-4 bg-white shadow rounded-xl overflow-x-auto">
      <h1 className="mb-4">Tournament Participation Summary</h1>
      <table className="min-w-full border border-gray-200 text-center">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border-b text-left">Tournament Type</th>
            <th className="px-4 py-2 border-b">Participated</th>
            <th className="px-4 py-2 border-b">Total Medals Won</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((type) => (
            <tr key={type} className="hover:bg-gray-50">
              <td className="px-4 py-2 border-b font-medium text-left">{type}</td>
              <td className="px-4 py-2 border-b">{grouped[type].tournaments.size}</td>
              <td className="px-4 py-2 border-b">{grouped[type].medals}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
